import React, { useEffect, useState } from "react";
import serviceApi from "../../../services/serviceApi";
import environment from "../../../environments/environment";

interface VehicleDetails {
    id?: string;
    rno?: string;
    model?: string;
}

interface DriverDetails {
    id?: string;
    name?: string;
    dlno?: string;
    contact1?: string;
    contact2?: string;
}

interface HelperDetails {
    id?: string;
    name?: string;
    contact1?: string;
}

interface TransportData {
    route?: string;
    droppoint?: string;
    starttime?: string;
    endtime?: string;
    vehicleDeatils?: VehicleDetails;
    driverDetails?: DriverDetails;
    helpherDetails?: HelperDetails;
}
declare global {
    interface Window {
        google: any;
    }
}

const Transport: React.FC = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState<TransportData | null>(null);
    const openMap = async () => {
        const mapTab = window.open("", "_blank");
        if (!mapTab) {
            alert("Please allow popups.");
            return;
        }
        mapTab.document.body.innerHTML = `<div id="map" style="width:100%;height:100vh;"></div>`;
        try {
            const res = await serviceApi.get(environment.liveGpsData);
            if (
                res?.status !== "SUCCESS" ||
                !res?.dataList ||
                res.dataList.length === 0
            ) {
                alert("Live location not available.");
                mapTab.close();
                return;
            }
            const script = mapTab.document.createElement("script");
            script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAighVbnV5yVAs3uyJjMwBt4BsCqrkGVBY';
            script.async = true;
            mapTab.document.body.appendChild(script);
            script.onload = () => {
                const vehiclesData = res.dataList;
                const map = new mapTab.google.maps.Map(
                    mapTab.document.getElementById("map"),
                    {
                        zoom: 12,
                        center: {
                            lat: Number(vehiclesData[0].latitude),
                            lng: Number(vehiclesData[0].longitude),
                        },
                    }
                );
                const bounds = new mapTab.google.maps.LatLngBounds();
                vehiclesData.forEach((v: any) => {
                    const position = {
                        lat: Number(v.latitude),
                        lng: Number(v.longitude),
                    };
                    bounds.extend(position);
                    const marker = new mapTab.google.maps.Marker({
                        position,
                        map,
                        title: v.vehicleName,
                        icon: {
                            url: "/bus.jpg",
                            scaledSize: new mapTab.google.maps.Size(40, 40)
                        }
                    });
                    const info = new mapTab.google.maps.InfoWindow({
                        content: `
                <b>${v.vehicleName}</b><br/>`,
                    });
                    marker.addListener("click", () => {
                        info.open(map, marker);
                    });
                });
                map.fitBounds(bounds);
            };
        } catch (err) {
            alert("Unable to fetch live location.");
        }
    };
    useEffect(() => {
        Transport();
    }, []);

    const Transport = async () => {
        setIsLoading(true);
        try {
            const res = await serviceApi.get(environment.transport);
            if (res?.status === "SUCCESS") {
                setData(res?.objectData || null);
            }
        } catch (err) {
            console.error("Transport fetch error", err);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="notification-page">
                <h2 className="title-text notification-heading">
                    Transport Details
                </h2>
                {isLoading && (
                    <div className="loading-overlay">
                        <div className="loading-overlay__content">
                            <div className="spinner spinner--lg"></div>
                            <span className="loading-text">
                                Loading transport details...
                            </span>
                        </div>
                    </div>
                )}
                {data && (
                    <div className="event-container" style={{ padding: "14px" }}>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginBottom: "8px"
                            }}
                        >
                            <div>
                                <div
                                    style={{
                                        fontSize: "11px",
                                        color: "#777"
                                    }}
                                >
                                    Route
                                </div>
                                <div
                                    style={{
                                        fontWeight: 700,
                                        color: "var(--colorPrimaryDark)"
                                    }}
                                >
                                    {data.route || "-"}
                                </div>
                            </div>

                            <div style={{ textAlign: "right" }}>
                                <div
                                    style={{
                                        fontSize: "11px",
                                        color: "#777"
                                    }}
                                >
                                    Drop Point
                                </div>
                                <div
                                    style={{
                                        fontWeight: 600
                                    }}
                                >
                                    {data.droppoint || "-"}
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                marginBottom: "10px",
                                fontSize: "13px",
                                fontWeight: 600
                            }}
                        >
                            Pickup: {data.starttime || "-"} | Drop: {data.endtime || "-"}
                        </div>
                        <div className="horizontal-divider" />
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                marginTop: "10px",
                                marginBottom: "14px"
                            }}
                        >
                            <div>
                                <div
                                    style={{
                                        fontSize: "11px",
                                        color: "#777"
                                    }}
                                >
                                    Vehicle No
                                </div>
                                <div style={{ fontWeight: 600 }}>
                                    {data.vehicleDeatils?.rno || "-"}
                                </div>
                            </div>
                            <div style={{ textAlign: "right" }}>
                                <div
                                    style={{
                                        fontSize: "11px",
                                        color: "#777"
                                    }}
                                >
                                    Model
                                </div>
                                <div
                                    style={{
                                        fontWeight: 600,
                                        color: "var(--colorAccent)"
                                    }}
                                >
                                    {data.vehicleDeatils?.model || "-"}
                                </div>
                            </div>
                        </div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                gap: "20px"
                            }}
                        >
                            <div
                                style={{
                                    flex: 1,
                                    fontSize: "12px",
                                    lineHeight: "20px"
                                }}
                            >
                                <div
                                    style={{
                                        fontWeight: 700,
                                        marginBottom: "4px"
                                    }}
                                >
                                    Driver
                                </div>
                                <div>{data.driverDetails?.name || "-"}</div>
                                <div>DL No: {data.driverDetails?.dlno || "-"}</div>
                                <div>
                                    <i className="fa fa-phone" />{" "}
                                    {data.driverDetails?.contact1 || "-"}
                                </div>
                                <div>
                                    <i className="fa fa-phone" />{" "}
                                    {data.driverDetails?.contact2 || "-"}
                                </div>
                            </div>
                            <div
                                style={{
                                    flex: 1,
                                    textAlign: "right",
                                    fontSize: "12px",
                                    lineHeight: "20px"
                                }}
                            >
                                <div
                                    style={{
                                        fontWeight: 700,
                                        marginBottom: "4px"
                                    }}
                                >
                                    Helper
                                </div>
                                <div>{data.helpherDetails?.name || "-"}</div>
                                <div>
                                    <i className="fa fa-phone" />{" "}
                                    {data.helpherDetails?.contact1 || "-"}
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
            <div
                className="event-container"
                style={{ cursor: "pointer" }}
                onClick={openMap}
            >
                <div>
                    <span>
                        <i className="fa fa-bus" style={{ color: " var(--colorPrimaryDark)" }}></i>{" "}
                        <i className="fa fa-location-dot" style={{ color: "var(--colorAccent)" }}></i>{" "}
                        Track Location
                    </span>
                </div>
            </div>
        </>
    );
};

export default Transport;